import { useState } from 'react';

const emptyFunction = () => void 0;

const usePagination = (size, total, defaultPage = 0) => {
  const [page, setPage] = useState(defaultPage);

  const lastPage = total === 0 ? 0 : Math.floor((total - 1) / size);

  const isLastPage = page === lastPage;
  const isFirstPage = page === 0;
  const goNext = !isLastPage ? () => setPage(page + 1) : emptyFunction;
  const goPrevious = !isFirstPage ? () => setPage(page - 1) : emptyFunction;
  const goTo = (page) => (page <= lastPage && page >= 0 ? setPage(page) : null);
  const goFirst = () => setPage(0);
  const goLast = () => setPage(lastPage);

  return { page, isLastPage, isFirstPage, goNext, goPrevious, goTo, goFirst, goLast };
};

export default usePagination;
